export const tabStyles = ({ spacing, shape, palette, customPalette }) => ({
  tabHeader: {},
  tabLabel: {
    lineHeight: 1.5,
    marginRight: spacing(2),
    "& + span": {
      fontWeight: 500,
    },
  },
  tabRoot: {
    marginRight: spacing(3),
    padding: `${spacing(2)} ${spacing(3)}`,
    borderRadius: `${shape.borderRadius}px`,
    opacity: 1,
    minWidth: spacing(24),
    "&:hover": {
      border: `1px solid ${palette.secondary.main}`,
      padding: `calc(calc(${spacing(2)} - 1px) ${spacing(3)} - 1px)`,
    },
  },
  tabSelected: {
    padding: `calc(${spacing(2)} ${spacing(3)} - 2px)`,

    border: `2px solid ${palette.secondary.main}`,
    backgroundColor: customPalette.primary[200],
    "&:hover": {
      border: `2px solid ${palette.secondary.main}`,
      padding: `calc(${spacing(2)} ${spacing(3)} - 2px)`,
    },
    "& $tabHeader, & $tabLabel": {
      color: palette.secondary.main,
    },
  },
  tabTotalWrapper: {
    padding: `${spacing(2)} ${spacing(3)}`,
    borderRight: `2px solid ${palette.action.disabled}`,
    maxWidth: spacing(26),
    "& span": {
      color: palette.text.primary,
    },
  },
  tabIndicator: {
    display: "none !important",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: `${spacing(4)} 0px`,
  },
  progress: {
    color: palette.secondary.light,
    position: "absolute",
    top: "50%",
    left: "45%",
  },
});
